/* This is a mst-gql generated file, don't modify it manually */
 
import { types } from "mobx-state-tree"



/**
* PatientSource
*/
export const PatientSourceEnumType = types.enumeration("PatientSource", [
        "APPOINTMENT",
  "APPOINTMENT_REQUEST",
      ])
